export default function Derrota({ nombre, color, today, fraseSeleccionada, secondsElapsed, clickContinuar, icono, palabra, idJuego}:
                                {nombre: any; color:any; today:any; fraseSeleccionada:any; secondsElapsed:any; clickContinuar:any; icono:any; palabra:any; idJuego:any;}) {

return (
    <div className="victory-message victory-message--derrota">
      <div className="content">
        <img src={"./"+icono} alt={nombre} className="game-logo" />
        <span className="fecha">{today}</span>
        <h2 className="derrota-titulo">¡Vaya, has perdido!</h2>

        <div className="derrota-info">
          <p className="derrota-palabra">La palabra era:<br/><strong>{palabra}</strong></p>
          <p className="derrota-tiempo">Tiempo: {secondsElapsed}</p>
        </div>

        <p className="victory-puzztime">Vuelve mañana para seguir jugando</p>
      </div>
    </div>
    )
}
